
import auth_ee from "./manager"

import {
  trackSignUp,
  trackSignIn,
} from "app/authentication/tracking"

auth_ee.on("sign_up:success:action", () => {
  trackSignUp()
})

auth_ee.on("sign_in:success:action", () => {
  trackSignIn()
})

